import {CallApi} from "./ApiCommon";
import {HomeDomain} from "./Config";
import {ApiRequestError} from "./ApiRequestError";

export const PostLogin = async (mail: string, pass: string) => {
  try {
    await CallApi(`https://${HomeDomain}/api_user/authentication`, {
      credentials: "include",
      method: "POST",
      body: JSON.stringify({
        mail: mail,
        pass: pass
      })
    }, false)
  } catch (e: any) {
    throw new ApiRequestError(e.message)
  }
}